const { hydrate } = require('@/lib/Hydration');
const { toInt, toIntArray } = require('@/functions/transform');

class WaiverDefinition {
    /**
     * @type {Number}
     */
    ID;

    /**
     * @type {Number[]}
     */
    itemIDs;

    constructor(data = {}) {
        console.log('WaiverDefinition construct data', data);
        hydrate(data, this);
    }

    getHydrationMap() {
        return {
            ID: toInt,
            itemIDs: toIntArray,
        };
    }
}

module.exports = WaiverDefinition;
